import * as Actions from '../../actions';

const initialState = { data: null };

const listDeferralReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_DEFERRALS_LIST_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default listDeferralReducer;
